import React from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import parse from 'date-fns/parse';
import format from 'date-fns/format';


const HabitActivitiesGraph = props => {
    // props
    let {data} = props;

    if (!data) {
        return (
            <div/>
        )
    }

    const dateFormatter = date => {
        const result =  parse(date, 'yyyy-MM-dd', new Date()).getTime();
        return format(result, 'MM/dd/yy');
    };

    data = data.map(val => {
        if (!val.value) delete val.value;
        return val;
    });

    return (
        <ResponsiveContainer width="100%" height="100%" debounce={1}>
            <LineChart
                data={data}
                margin={{
                    top: 15,
                    right: 0,
                    left: 0,
                    bottom: 0,
                }}
            >
                <XAxis
                    dataKey="date"
                    tickFormatter={dateFormatter}/>
                <YAxis />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="value" stroke="#6ba543" fill="#6ba543" dot={true} />
            </LineChart>
        </ResponsiveContainer>
    )
}

export default HabitActivitiesGraph;